import api from '../../../../helpers/api';

export const getTypesOfResidence = (payload: any) => {
  return api.post(`developer/platform/family-income/housing-type`, payload);
};

export const getDwellersByResidence = (payload: any) => {
  return api.post(
    `developer/platform/family-income/residents-per-household`,
    payload
  );
};

export const getResidenceCondition = (payload: any) => {
  return api.post(
    `developer/platform/family-income/housing-condition`,
    payload
  );
};

export const getGenderDistribution = (payload: any) => {
  return api.post(
    `developer/platform/family-income/gender-distribution`,
    payload
  );
};

export const getAgeDistribution = (payload: any) => {
  return api.post(
    `developer/platform/family-income/population-by-age-group`,
    payload
  );
};

export const getPopulationGrowth = (payload: any) => {
  return api.post(
    `developer/platform/family-income/population-growth`,
    payload
  );
};

export const getHouseholdsByIncome = (payload: any) => {
  return api.post(
    `developer/platform/family-income/households-per-income-bracket`,
    payload
  );
};

export const getActivePopulation = (payload: any) => {
  return api.post(
    `developer/platform/family-income/active-population`,
    payload
  );
};

export const getConsumptionByIncome = (payload: any) => {
  return api.post(
    `developer/platform/family-income/consumption-potential-by-income`,
    payload
  );
};

export const getConsumptionByGoods = (payload: any) => {
  return api.post(
    `developer/platform/family-income/consumption-potential-by-goods-category`,
    payload
  );
};
